module.exports = __webpack_public_path__ + "media/images/hero_banner_sp-ee4b0260fc4345058569701f5834db70.png";